import { ref } from 'vue';
import { BookingAllowedStatus } from '@/widgets/Wizard/models/time-table/status';
import type { Account } from '@/widgets/Wizard/models/accounts';
import type { TimeTableGateway } from '@/widgets/Wizard/gateways/time-table';

export function useTimeTableBookStatus() {
    const activeBookStatus = ref<BookingAllowedStatus>(BookingAllowedStatus.UNSET);

    const updateBookStatus = (status: BookingAllowedStatus) => {
        activeBookStatus.value = status;
    };

    return {
        activeBookStatus,

        updateBookStatus,
    };
}

export async function checkTimeTableBookStatus(
    timeTable: TimeTableGateway,
    account: Account,
): Promise<BookingAllowedStatus> {
    return await timeTable.getBookingStatus(account);
}
